import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Platform } from '@ionic/angular/standalone';
import { IonCol, IonGrid, IonRow } from '@ionic/angular/standalone';
import { Attachment } from 'src/app/models/item.model';
import { SecurePipe } from '../secure.pipe';

@Component({
  selector: 'app-attachment-collage',
  templateUrl: './attachment-collage.component.html',
  styleUrls: ['./attachment-collage.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, SecurePipe, IonGrid, IonRow, IonCol]
})
export class AttachmentCollageComponent implements OnInit {
  @Input() attachments: Attachment[];
  @Output() imageSelected = new EventEmitter<string>();
  @Output() getThumb = new EventEmitter<string>();
  public attachmentGrid = [];
  public hasFileSystem;

  constructor(
    platform: Platform,
    private domSanitizer: DomSanitizer
  ) {
    this.hasFileSystem = platform.is('hybrid');
  }

  ngOnInit(): void {
    if (this.attachments.length === 0) {
      return;
    }
    for (let row = 0; row < this.getRows(); row++) {
      const rowItems: string[] = [];
      for (let col = 0; col < this.getCols(row); col++) {
        const item = this.getAttachment(row, col);
        if (this.hasFileSystem && !item.thumbUrl) {
          this.getThumb.emit(item.attachmentId);
        }
        rowItems.push(item.attachmentId);
      }
      this.attachmentGrid.push(rowItems);
    }
  }
  getRows(): number {
    return this.attachments.length < 3 ? 1 : 2;
  }
  getCols(row: number): number {
    if (row === 0) {
      return [1, 3].includes(this.attachments.length) ? 1 : 2;
    }
    return 2;
  }

  getAttachment(row: number, col: number): Attachment {
    if (row === 0) {
      return this.attachments[col];
    }
    return this.attachments[this.attachments.length < 4 ? 1 + col : 2 + col];
  }

  id(id: string): Attachment {
    return this.attachments.find(a => a.attachmentId === id);
  }

  thumbUrl(item: Attachment): string {
    return item.url + '?thumb=true';
  }

  sanitizeUrl(url: string): SafeResourceUrl {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
